export const CustomerManagementResidentStatusEnum = {
  NonUS: "NON-US",
  US: "US",
};

export const CustomerManagementEmploymentStatusEnum = {
  Employed: "EMPLOYED",
  SelfEmployed: "SELF_EMPLOYED",
  Retired: "RETIRED",
  Student: "STUDENT",
  Unemployed: "UNEMPLOYED",
};

export const CustomerManagementUnderstandRiskEnum = {
  Yes: "Y",
  No: "N",
};

export const CustomerManagementTradingExperienceEnum = {
  Beginner: "BEGINNER",
  Intermediate: "INTERMEDIATE",
  Advanced: "ADVANCED",
};

export const CustomerManagementDocumentTypeEnum = {
  ProofOfIdentity: "PROOF_OF_IDENTITY",
  ProofOfAddress: "PROOF_OF_ADDRESS",
};

export const CustomerManagementDocumentCategoryEnum = {
  NationalId: "ID_CARD",
  Passport: "PASSPORT",
  // Drivers: "DRIVERS",
  // ResidencePermit: "RESIDENCE_PERMIT",
  // BankStatement: "BANK_STATEMENT",
  // LocalAuthorityTaxBill: "LOCAL_AUTHORITY_TAX_BILL",
  // UtilityBill: "UTLITY_BILL",
};

export const CustomerManagementDocumentSideEnum = {
  FrontSide: "FRONT_SIDE",
  BackSide: "BACK_SIDE",
  None: "NONE",
};

export const CustomerManagementPlatformEnum = {
  MetaTrader: "METRADER 5",
  MatchTrader: "MATCHTRADER PRO",
};

export const CustomerManagementOnBoardingStatusEnum = {
  Pending: "PENDING",
  Success: "SUCCESS",
  Failed: "FAILED",
};

export const CustomerManagementKYCDocumentsStatusEnum = {
  Submitted: "SUBMITTED",
  PendingUpload: "PENDING_UPLOAD",
  Sent: "SENT",
  PendingVerification: "PENDING_VERIFICATION",
  OngoingVerification: "ONGOING_VERIFICATION",
  VerifiedSuccessfully: "VERIFIED_SUCCESSFULLY",
  ErrorInVerification: "ERROR_IN_VERIFICATION",
  Blocked: "BLOCKED",
};

export const CustomerManagementNotificationPlatformsEnum = {
  Sms: "SMS",
  WhatsApp: "WHATSAPP",
};

export const CustomerManagementOTPPurposeEnum = {
  SignUp: "SIGN_UP",
  PhoneNumberVerification: "PHONENUMBER_VERIFICATION",
  ForgotPassword: "FORGOT_PASSWORD",
  ChangeProfilePassword: "CHANGE_PROFILE_PASSWORD",
};

export const CustomerManagementIntroducingBrokerStatusEnum = {
  NotRequested: "NOT_REQUESTED",
  Pending: "PENDING",
  Approved: "APPROVED",
};

export const CustomerManagementUserContactEnum = {
  PHONE: "PHONE",
  EMAIL: "EMAIL",
};
